import type { FC } from "react";
import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";
import styled from "styled-components";

const HeaderCell = styled.div`
    width: 100%;
`;

const DesktopMobileText = styled.div`
    width: 100%;

    padding-top: 20px;
`;

export const DesktopMobileHeaderCell: FC<ITableHeaderCellProps> = ({ displayName }) => {
    return (
        <HeaderCell className="headerCell">
            <DesktopMobileText className="desktopMobile-text">{displayName}</DesktopMobileText>
            <div className="desktopMobile-icon">
                <i className="sw-icon-desktop--thin"></i>
                <i className="sw-icon-mobile--thin"></i>
            </div>
        </HeaderCell>
    );
};
DesktopMobileHeaderCell.displayName = "DesktopMobileHeaderCell";
